import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import RequireAuth from "@/components/RequireAuth";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Search from "@/pages/Search";
import ListingDetail from "@/pages/ListingDetail";
import Profile from "@/pages/Profile";
import Trips from "@/pages/Trips";
import HostDashboard from "@/pages/HostDashboard";
import ListingEditor from "@/pages/ListingEditor";
import ComplaintDetail from "@/pages/ComplaintDetail";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import NonDiscrimination from "@/pages/NonDiscrimination";
import { HostAgreement, GuestTerms, PrivacyPolicy, TermsOfService } from "@/pages/Legal";
import HostPayouts from "@/pages/HostPayouts";
import Storefront, { StoreSuccess } from "@/pages/Storefront";
import PayBooking from "@/pages/PayBooking";
import Receipt from "@/pages/Receipt";
import TaxFiling from "@/pages/TaxFiling";
import AnnualStatement from "@/pages/AnnualStatement";
import CpaPack from "@/pages/CpaPack";

function AppRouter() {
  const location = useLocation();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const guard = (el, admin) => <RequireAuth admin={admin}>{el}</RequireAuth>;
  return (
    <>
      <Navbar />
      <main className="min-h-[70vh]">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/search" element={<Search />} />
          <Route path="/listings/:id" element={<ListingDetail />} />
          <Route path="/users/:id" element={<Profile />} />
          <Route path="/trips" element={guard(<Trips />)} />
          <Route path="/host" element={guard(<HostDashboard />)} />
          <Route path="/host/payouts" element={guard(<HostPayouts />)} />
          <Route path="/host/tax-filing" element={guard(<TaxFiling />)} />
          <Route path="/store/:accountId" element={<Storefront />} />
          <Route path="/store/:accountId/success" element={<StoreSuccess />} />
          <Route path="/host/listings/new" element={guard(<ListingEditor />)} />
          <Route path="/host/listings/:id/edit" element={guard(<ListingEditor />)} />
          <Route path="/complaints/:id" element={guard(<ComplaintDetail />)} />
          <Route path="/admin" element={guard(<Admin />, true)} />
          <Route path="/admin/cpa-pack" element={guard(<CpaPack />, true)} />
          <Route path="/host/annual-statement" element={guard(<AnnualStatement />)} />
          <Route path="/trips/:bookingId/pay" element={guard(<PayBooking />)} />
          <Route path="/trips/:bookingId/receipt" element={guard(<Receipt />)} />
          <Route path="/payment/success" element={guard(<PaymentSuccess />)} />
          <Route path="/non-discrimination" element={<NonDiscrimination />} />
          <Route path="/host-agreement" element={<HostAgreement />} />
          <Route path="/guest-terms" element={<GuestTerms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
